module.exports = __webpack_public_path__ + "img/LogoBNI.1a902800.png";